export default "__VITE_ASSET__07f4e649__"